<template>

<div>

  <b-card>
    <h5>Cari data</h5>

    <div class="form-group row">
      <label class="col-2 col-form-label">Cabang</label>
      <div class="col-3">
        <BranchListComponent
          :value="filter.branchId"
          @value="filter.branchId = $event"/>
      </div>
    </div>

    <div class="form-group row">
      <label class="col-2 col-form-label">Nama Karyawan</label>
      <div class="col-3">
        <EmployeeListComponent
          :value="filter.employeeId"
          @value="filter.employeeId = $event"
          :isLoadingEmployeeList="isLoadingEmployeeList"
          filterBy="branch"
          :filterValue="filterValue"/>
      </div>
    </div>

    <div class="form-group row">
      <label class="col-2 col-form-label">Tanggal</label>
      <div class="col-3">
        <b-form-input v-model="filter.startDate" class="form-control" type="date"></b-form-input>
      </div>
      <div class="col-0 d-flex align-items-center">
        <span>s/d</span>
      </div>
      <div class="col-3">
        <b-form-input v-model="filter.endDate" class="form-control" type="date"></b-form-input>
      </div>
    </div>

    <b-row class="mb-1">
      <b-col>
        <b-button
          class="px-2 d-inline align-items-center mr-2"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          @click="filterData()">
          Cari
        </b-button>
        <!-- <b-button
          class="px-2 d-inline align-items-center"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="light"
          @click="resetFilter()">
          Reset
        </b-button> -->
      </b-col>
    </b-row>



  </b-card>

<b-card>

  <BaseTable
    :fields="fields"
    :items="items"
    :loading="loading"
    :rows="pagination.total"
    :perPage="filter.size"
    :currentPage="filter.page"
    :handle-page-change="handlePageChange"
    :detail-item="detailItem"
    :edit-item="editItem"
    :delete-item="deleteItem"
    hide-update
  />

  <DetailReimburse
    :page-title="pageTitle"
    :result="detail"
    :image="image"
  />

</b-card>

</div>

</template>

<script>
import _ from "lodash";
import Ripple from "vue-ripple-directive";

import { ReimburseService } from '@/services/reimburse.service'

import { BCard, BRow, BCol, BButton, BFormInput, BSpinner } from "bootstrap-vue";
import { successNotification, errorNotification } from "@/auth/utils";
import vSelect from "vue-select";

import BaseTable from "@/components/BaseTable.vue";
import DetailReimburse from "@/components/Reimburse/DetailReimburse.vue";
import BranchListComponent from "@/components/Base/BranchListComponent.vue";
import EmployeeListComponent from "@/components/Base/EmployeeListComponent.vue";
import utility from '../libs/utility'

export default {
  name: 'ReimbursePage',

  components: {
    BaseTable,
    BCard,
    BRow,
    BCol,
    BButton,
    BFormInput,
    BSpinner,
    vSelect,
    DetailReimburse,
    BranchListComponent,
    EmployeeListComponent
},

  directives: {
    Ripple,
  },

  watch: {
    'filter.page'() {
      this.fetchData()
    },
    'filter.branchId'(value) {
      this.isLoadingEmployeeList = false
      this.filterValue = null
      if (value !== null) {
        this.isLoadingEmployeeList = false
        this.filterValue = value
      }
    },
  },

  setup () {
    return {
      successNotification,
      errorNotification,
      BaseTable,
    };
  },

  data () {
    return {
      key: 'reimburse',
      pageTitle: 'Pengumuman',
      items: [],
      detail: Object,
      error: false,
      image: '',
      loading: false,
      pagination: {
        total: 0
      },
      filter: {
        branchId: "",
        employeeId: "",
        startDate: "",
        endDate: "",
        page: 1,
        size: 10,
        reimburseColumn: 'REIMBURSE_DATE',
        sortDirection: 'DESC',
      },
      fields: [
        {
          key: "no",
          label: "No",
          width: '50px',
        },
        {
          key: "employee",
          label: "Nama Karyawan",
        },
        {
          key: "reimburseDate",
          label: "Tgl Pengajuan",
        },
        {
          key: "reimburseCategory",
          label: "Jenis Reimburse",
        },
        {
          key: "amount",
          label: "Biaya",
        },
        {
          key: "totalDiscovery",
          label: "Total dicover (%)",
        },
        {
          key: "statusApproval",
          label: "Status",
        },
        {
          key: "actions",
          label: "Aksi",
          width: '200px'
        },
      ],
      editId: null,
      formPayload: Object,
      isLoadingEmployeeList: false,
      filterValue: null,
    }
  },

  methods: {
    cleanUpForm() {
      this.editId = null;
      this.formPayload = {
        title: '',
        description: '',
        file: '',
      };
    },
    filterData() {
      this.fetchData()
    },
    // resetFilter() {
    //   this.branchId = "",
    //   this.employeeId = "",
    //   this.startDate = "",
    //   this.endDate = "",
    //   this.page = 1,
    //   this.size = 10
    //   this.fetchData()
    // },
    async fetchData () {
      this.prepareFilter()
      this.loading = true
      try {
        const { data } = await ReimburseService.findAll(this.filter)

        this.items = data.content
        this.pagination.total = data.total
      } catch (e) {

      } finally {
        this.loading = false
      }
    },
    detailItem(item) {
      window.console.log(item);
      let params = {
        fileName: item.file
      };
      this.loading = true;
      this.$http.get(`/employee-activity/reimburse`, { "responseType": 'blob' ,params: params})
        .then((result) => {
          window.console.log(result);
          const reader          = new FileReader();
          reader.readAsDataURL(result.data);
          reader.onloadend      = function () {
            item['filePath'] = reader.result;
            localStorage.setItem('filePath', reader.result);
          }
          window.console.log(item);
          this.loading = false;
          this.detail = item;
          this.$bvModal.show('detail-'+ this.key + '-modal');
        })
        .catch((e) => {
          this.loading = false;
          localStorage.setItem('filePath', '');
          errorNotification(this, "Oops!", e.message);
          let imageDefault = require('../assets/images/default.png');
          item['filePath'] = imageDefault;
          this.detail = item;
          this.$bvModal.show('detail-'+ this.key + '-modal');
        });
    },
    editItem(item) {
      this.editId = item.id;
      this.formPayload = {
        title: item.title,
        description: item.description,
      };
      this.showFormModal()
    },
    async createItem() {
      this.loading = true

      try {
        await ReimburseService.create(this.preparePayload())
        successNotification(this, "Success", `${this.pageTitle} berhasil dibuat!`);
        this.hideFormModal()
        this.fetchData()
      } catch (e) {
        this.error = e.message
        errorNotification(this, "Oops!", e.message);
      } finally {
        this.loading = false
      }
    },
    async updateItem() {
      this.loading = true

      try {
        await ReimburseService.update(this.editId, this.preparePayload())
        successNotification(this, "Success", `${this.pageTitle} berhasil diubah!`);
        this.hideFormModal()
        this.fetchData()
      } catch (e) {
        this.error = e.message
        errorNotification(this, "Oops!", e.message);
      } finally {
        this.loading = false
      }
    },
    deleteItem(item) {
      this.$swal({
        title: "Anda yakin?",
        text: "Anda yakin ingin menghapus data ini?",
        icon: "warning",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.value) {
          try {
            await ReimburseService.delete(item.id)
            successNotification(this, "Success", `${this.pageTitle} berhasil dihapus!`);
            this.hideFormModal()
            this.fetchData()
          } catch (e) {
            this.error = e.message
            errorNotification(this, "Oops!", e.message);
          } finally {
            this.loading = false
          }
        }
      });
    },
    getPayload(value) {
      if (value) {
        this.formPayload = value;
      }
    },
    prepareFilter() {
      for (const key in this.filter) {
        if (
          this.filter.hasOwnProperty(key) &&
          this.filter[key] != null
        ) {
          if (this.filter[key] == null || this.filter[key] == "") {
            delete this.filter[key]
          }
        }
      }
      return this.filter
    },
    preparePayload() {
      const form = new FormData();
      for (const key in this.formPayload) {
        if (
          this.formPayload.hasOwnProperty(key) &&
          this.formPayload[key] != null
        ) {
          form.append(key, this.formPayload[key]);
        }
      }

      return form;
    },
    showFormModal() {
      this.$bvModal.show(`form-${this.key}-modal`);
    },
    hideFormModal() {
      this.$bvModal.hide(`form-${this.key}-modal`);
    },
    handlePageChange(value) {
      this.loading = true
      this.filter.page = value;
    },
  },

  created () {
    this.fetchData()
  }

}

</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
